(function () {
  var avalnaScrollTopBtn = document.querySelector('.avalna-scroll-top');
  if (!avalnaScrollTopBtn) return;

  var avalnaScrollTopVisible = false;
  var avalnaScrollTopTicking = false;
  var AVALNA_SCROLL_THRESHOLD = 300;

  function avalnaUpdateScrollTop() {
    var shouldShow = window.scrollY > AVALNA_SCROLL_THRESHOLD;
    if (shouldShow !== avalnaScrollTopVisible) {
      avalnaScrollTopVisible = shouldShow;
      avalnaScrollTopBtn.classList.toggle('avalna-scroll-top--visible', shouldShow);
    }
    avalnaScrollTopTicking = false;
  }

  window.addEventListener('scroll', function () {
    if (!avalnaScrollTopTicking) {
      avalnaScrollTopTicking = true;
      requestAnimationFrame(avalnaUpdateScrollTop);
    }
  }, { passive: true });

  avalnaScrollTopBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
